export type Room = { adults: number; children: number }

export function parseRoomConfig(roomConfig: string | null): Room[] | null {
  if (!roomConfig) return null
  try {
    const parsed = roomConfig.split(',').map((segment) => {
      const [a, c] = segment.split('-').map(Number)
      return { adults: a >= 1 ? a : 1, children: c >= 0 ? c : 0 }
    })
    return parsed.length > 0 ? parsed : null
  } catch {
    return null
  }
}

// Build a roomConfig string ("adults-children,adults-children,…") from total
// guest counts, distributing as evenly as possible across rooms with at least
// one adult per room. Used by entry points that only track totals.
export function buildRoomConfig(adults: number, children: number, rooms: number): string {
  const roomCount = Math.max(1, rooms)

  const distribute = (total: number, perRoomMin: number): number[] => {
    const counts = Array.from({ length: roomCount }, () => perRoomMin)
    let remaining = Math.max(0, total - perRoomMin * roomCount)
    let i = 0
    while (remaining > 0) {
      counts[i % roomCount] += 1
      remaining--
      i++
    }
    return counts
  }

  // Ensure each room has at least one adult.
  const adultCounts = distribute(Math.max(adults, roomCount), 1)
  const childCounts = distribute(Math.max(0, children), 0)

  return adultCounts.map((a, idx) => `${a}-${childCounts[idx]}`).join(',')
}
